import dayjs from 'dayjs';
import { MatrialFilterFormValues, MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form/types';
import { StationTable } from 'features/master/components/table/station-table';
import { StationTopBar } from 'features/master/components/top-bar/station-top-bar';
import { useGetStationList } from 'features/master/use-cases/get-station';
import { usePaginationParams } from 'hooks';
import { omit } from 'lodash';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { formatDate } from 'utils/date';
// features/master/components
const getInitialFilterValues: MatrialFilterFormValues = {
  date: [undefined, undefined],
  Title: undefined,
  phone_number: undefined,
  email: undefined,
  role: undefined,
  Type:undefined
};

const preparePayload = (params: MatrialFilterFormValuesPaginated) => {
  const createdAtFrom = params.date?.[0];
  const createdAtTo = params.date?.[1];

  return {
    ...omit(params, ['date']),
    type: 1,
    created_at_from: createdAtFrom
      ? formatDate({
        date: dayjs(createdAtFrom).startOf('day'),
        format: 'dbDate',
      })
      : undefined,
    created_at_to: createdAtTo
      ? formatDate({
        date: dayjs(createdAtTo).endOf('day'),
        format: 'dbDate',
      })
      : undefined,
  };
};

export const StationMasterView = () => {
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);

  const { params, updateParams, resetPage } =
    usePaginationParams<MatrialFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });

  const getmasterListQueryResponse: any = useGetStationList(preparePayload(params), {
    retry: false,
  });
  
  const handleFiltersChange = (values: MatrialFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <StationTopBar
        getInitialFilterValues={getInitialFilterValues}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getmasterListQueryResponse.refetch}
      />
      <StationTable
        ismasterListLoading={
          getmasterListQueryResponse.isFetching
        }
        masterList={getmasterListQueryResponse?.data?.rc}
        itemsCount={getmasterListQueryResponse.data?.totalRecords || 0}
        tableParams={params}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getmasterListQueryResponse.refetch}
        isFetching={ getmasterListQueryResponse.isFetching}
      />
      <Outlet />
    </>
  );
};
